export default {
  welcome: '欢迎使用 Rapoo A-Hub',
  changeLang: '切换语言',
  toggleTheme: '切换主题',
  device: '设备管理',
  about: '关于我们',
  add: '添加',
  backButton: '返回',
  cancel: '取消',
  Deselect: '取消选择',
  confirm: '确认',
  confirm2: '确定',
  delete: '删除',
  noDisabled: '不再显示',
  save: '保存',
  clear: '清空',
  withdraw: '撤回',
  confirmDelete: '确认删除',
  loading: '加载中...',
  footerTab: {
    lighting: '灯光',
    itinerary: '行程',
    keys: '改键',
    keyboardSettings: '键盘设置',
    keyboardPerformanceSettings: '性能设置',
    dpi: 'DPI 设置',
    performance: '性能',
    rt: '按键触发',
    parameters: '参数',
    mouseSettings: '鼠标设置',
    pages: '添加页面',
    playback: '播放设置',
    baseSettings: '底座设置',
  },
  products: {
    A83_Air: {
      Glass_Blue: '雪青',
    },
    ESK900_75RT: {
      Blade_Pink: '锋刃粉',
    },
    ESK900_83RT: {
      Black_Mist: '黑雾',
      Phantom_Green: '墨冰雾影',
      Translucent_Black: '暗影刺客',
    },
    ESK900_98RT: {
      Abyss_Ranger: '暗渊游侠',
      Blaze_Wing_Star: '炽翼星魂',
      Hacker_Agent: '骇客特工',
      Infernal_Asura: '炼狱修罗',
      Zero_Flame: '零号赤焰',
    },
    ESM612PRO: {
      Raspberry_Pink: '绯焰风暴',
      Gray_Black_Red: '零号赤焰',
      Black_Gray_Orange: '炼狱修罗',
      White_Black_Yellow: '炽翼星魂',
      Black_Purple_Green: '暗渊游侠',
      Vajra_Red: '热血硬派',
      Emerald_Wind: '绝地极光',
      Flame_Orange: '灼影橙',
      Black_Gray_Green: '骇客特工',
    },
    ESM612MAX: {
      Raspberry_Pink: '绯焰风暴',
      Gray_Black_Red: '零号赤焰',
      Black_Gray_Orange: '炼狱修罗',
      White_Black_Yellow: '炽翼星魂',
      Black_Purple_Green: '暗渊游侠',
      Vajra_Red: '热血硬派',
      Iridescent_Green: '绝地极光',
      Black_Gray_Green: '骇客特工',
    },
    ESM612ACE: {
      Raspberry_Pink: '绯焰风暴',
      Gray_Black_Red: '零号赤焰',
      Black_Gray_Orange: '炼狱修罗',
      White_Black_Yellow: '炽翼星魂',
      Black_Purple_Green: '暗渊游侠',
      Vajra_Red: '热血硬派',
      Darkthorn: '暗影荆棘',
      Black_Gray_Green: '骇客特工',
    },
    ESM622PRO: {
      Gray_Black_Red: '零号赤焰',
      Black_Gray_Orange: '炼狱修罗',
      White_Black_Yellow: '炽翼星魂',
      Black_Purple_Green: '暗渊游侠',
      Black_Gray_Green: '骇客特工',
    },
    ESM622MAX: {
      Gray_Black_Red: '零号赤焰',
      Black_Gray_Orange: '炼狱修罗',
      White_Black_Yellow: '炽翼星魂',
      Black_Purple_Green: '暗渊游侠',
      Phantom_Green: '墨影雾冰',
      Black_Gray_Green: '骇客特工',
    },
    ESM652PRO: {
      Raspberry_Pink: '绯焰风暴',
      Gray_Black_Red: '零号赤焰',
    },
    ESM672PRO: {
      Gray_Black_Red: '零号赤焰',
      Black_Gray_Orange: '炼狱修罗',
      White_Black_Yellow: '炽翼星魂',
      Black_Purple_Green: '暗渊游侠',
      Black_Gray_Green: '骇客特工',
    },
    ESM672MAX: {
      Gray_Black_Red: '零号赤焰',
      Black_Gray_Orange: '炼狱修罗',
      White_Black_Yellow: '炽翼星魂',
      Black_Purple_Green: '暗渊游侠',
      Black_Gray_Green: '骇客特工',
    },
    ESPR5: {
      Gray_Black_Red: '零号赤焰',
      Raspberry_Pink: '绯焰风暴',
    },
    ESPR7: {
      Emerald_Wind: '青岚',
      Blazing_Sun_Orange: '灼阳橙',
    },
    ESPR7PRO: {
      Gray_Black_Red: '零号赤焰',
      Raspberry_Pink: '绯焰风暴',
    },
    ESPR8: {
      Black_Purple_Green: '暗渊游侠',
      White_Black_Yellow: '炽翼星魂',
      Raspberry_Pink: '绯焰风暴',
      Black_Gray_Green: '骇客特工',
      Black_Gray_Orange: '炼狱修罗',
      Gray_Black_Red: '零号赤焰',
    },
    ESPR8PRO: {
      Iridescent_Green: '绝地极光',
      Phantom_Green: '墨影雾冰',
    },
    P5_PLUS: {
      Black: '黑色',
      White: '白色',
      Raspberry_Pink: '树莓粉',
      Flame_Orange: '焰影橙',
    },
    P6_PLUS: {
      Black: '黑色',
      White: '白色',
    },
    V700diy_75: {
      White_Gray_Blue: '幻影机甲',
      Black_Gray_Green: '初号骑士',
      Blue_Gray_Pink: '莫奈仙踪',
    },
    V700diy_87: {
      White_Gray_Blue: '幻影机甲',
      Black_Gray_Green: '初号骑士',
      Blue_Gray_Pink: '莫奈仙踪',
    },
    V700diy_98: {
      White_Gray_Blue: '幻影机甲',
      Black_Gray_Green: '初号骑士',
      Blue_Gray_Pink: '莫奈仙踪',
    },
    VT0: {
      Black: '星空黑',
      Frozen_Blue: '凝霜蓝',
      White: '皎月白',
    },
    VT0_MAX: {
      Black: '星空黑',
      Frozen_Blue: '凝霜蓝',
    },
    VT0Air_MAX: {
      Graffiti_Pink: '次元粉',
      Graffiti_Purple: '街头紫',
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT0_MAX_MASTER: {
      Metallic_Iridescent: '幻彩',
    },
    VT1: {
      Black: '星空黑',
      Flame_Orange: '焰影橙',
      White: '皎月白',
    },
    VT1_MAX: {
      Black: '星空黑',
      Flame_Orange: '焰影橙',
      White: '皎月白',
    },
    VT1_SE: {
      Black: '星空黑',
    },
    VT1S_V2: {
      Black: '星空黑',
      Flame_Orange: '焰影橙',
      White: '皎月白',
    },
    VT1S_MAX_V2: {
      Black: '星空黑',
      Flame_Orange: '焰影橙',
      White: '皎月白',
    },
    VT2: {
      Black: '星空黑',
      Fluorescent_Yellow: '炽光黄',
      Lava_Red: '熔岩红',
      Raspberry_Pink: '树莓粉',
      Skyline_Violet: '电驭紫',
      White: '皎月白',
    },
    VT2_MAX: {
      Black: '星空黑',
      Fluorescent_Yellow: '炽光黄',
      Lava_Red: '熔岩红',
      Raspberry_Pink: '树莓粉',
      Skyline_Violet: '电驭紫',
      White: '皎月白',
    },
    VT2_RT_V2: {
      Polar_Day: '极昼',
      Sakura_Glide: '掠樱',
      Liquid_Silver: '液态',
    },
    VT2_RT_MASTER_V2: {
      First_Light: '破晓',
      Night_Erosion: '夜蚀',
      Void: '虚空',
    },
    VT2K_MAX: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT2_V2: {
      Black: '星空黑',
      White: '皎月白',
      Lava_Red: '熔岩红',
    },
    VT2S_V2: {
      Black: '星空黑',
      Lava_Red: '熔岩红',
      White: '皎月白',
    },
    VT2_MAX_V2: {
      Black: '星空黑',
      White: '皎月白',
      Lava_Red: '熔岩红',
      Raspberry_Pink: '树莓粉',
    },
    VT2S_MAX_V2: {
      Black: '星空黑',
      White: '皎月白',
      Lava_Red: '熔岩红',
    },
    VT2Air_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT2SAir_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT2_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT2S_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT2_ULTRA_V2: {
      Metallic_Crimson: '锻绯红',
    },
    VT3: {
      Black: '星空黑',
      Flame_Orange: '焰影橙',
      Ice_Berry_Pink: '冰莓粉',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT3S: {
      Black: '星空黑',
      Flame_Orange: '焰影橙',
      Fluorescent_Yellow: '炽光黄',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT3_MAX: {
      Black: '星空黑',
      Ice_Berry_Pink: '冰莓粉',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT3S_MAX: {
      Black: '星空黑',
      Fluorescent_Yellow: '炽光黄',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT3S_MAX_MASTER: {
      Metallic_Iridescent: '幻彩',
    },
    VT3_V2: {
      Black: '星空黑',
      Fluorescent_Yellow: '炽光黄',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT3S_V2: {
      Black: '星空黑',
      Fluorescent_Yellow: '炽光黄',
      Raspberry_Pink: '树莓粉',
      Lava_Red: '熔岩红',
      White: '皎月白',
    },
    VT3S_Air_Max: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT3_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT3_PRO_V2: {
      Fluorescent_Yellow: '炽光黄',
      White: '皎月白',
    },
    VT3S_PRO_V2: {
      Black: '星空黑',
      Fluorescent_Yellow: '炽光黄',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
      Lava_Red: '熔岩红',
    },
    VT3_MAX_V2: {
      Black: '星空黑',
      Fluorescent_Yellow: '炽光黄',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT3S_MAX_V2: {
      Black: '星空黑',
      Fluorescent_Yellow: '炽光黄',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT3Air_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT3SAir_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT3S_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT4_V2: {
      Black: '星空黑',
      Mint_Green: '薄雾绿',
      White: '皎月白',
    },
    VT4_MAX_V2: {
      Black: '星空黑',
      Mint_Green: '薄雾绿',
      White: '皎月白',
    },
    VT4Air_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT4_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT6: {
      Black: '星空黑',
      Desert_Brown: '陨漠棕',
      White: '皎月白',
    },
    VT6_MAX: {
      Black: '星空黑',
      Desert_Brown: '陨漠棕',
      White: '皎月白',
    },
    VT7: {
      Black: '星空黑',
      Deep_Blue: '星渊蓝',
      Flame_Orange: '灼影橙',
      Metallic_Blue: '夜光蓝',
      Metallic_Crimson: '锻绯红',
      Metallic_Purple: '魅影紫',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT7_MAX: {
      Black: '星空黑',
      Flame_Orange: '灼影橙',
      Metallic_Blue: '夜光蓝',
      Metallic_Crimson: '锻绯红',
      Metallic_Purple: '魅影紫',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT7_V2: {
      Black: '星空黑',
      Raspberry_Pink: '树莓粉',
      Snowpeak_Blue: '雪山蓝',
      White: '皎月白',
      Lava_Red: '熔岩红',
    },
    VT7S_V2: {
      Black: '星空黑',
      Raspberry_Pink: '树莓粉',
      Snowpeak_Blue: '雪山蓝',
      White: '皎月白',
      Lava_Red: '熔岩红',
    },
    VT7_PRO_V2: {
      Black: '星空黑',
      Snowpeak_Blue: '雪山蓝',
      White: '皎月白',
    },
    VT7_SE: {
      Black: '星空黑',
    },
    VT7S_PRO_V2: {
      Black: '星空黑',
      Raspberry_Pink: '树莓粉',
      Snowpeak_Blue: '雪山蓝',
      White: '皎月白',
    },
    VT7_MAX_V2: {
      Black: '星空黑',
      White: '皎月白',
      Raspberry_Pink: '树莓粉',
      Snowpeak_Blue: '雪山蓝',
    },
    VT7S_MAX_V2: {
      Black: '星空黑',
      Snowpeak_Blue: '雪山蓝',
      White: '皎月白',
    },
    VT7Air_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT7SAir_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT7_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT7S_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT8_V2: {
      Black: '星空黑',
      White: '皎月白',
      Misty_Shadow_Gray: '影雾灰',
    },
    VT8_MAX_V2: {
      Black: '星空黑',
      White: '皎月白',
      Misty_Shadow_Gray: '影雾灰',
    },
    VT8Air_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT8_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT9: {
      Black: '星空黑',
      Electric_Purple: '电光紫',
      Flame_Orange: '灼影橙',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT9_MAX: {
      Black: '星空黑',
      Electric_Purple: '电光紫',
      White: '皎月白',
    },
    VT9_V2: {
      Black: '星空黑',
      Electric_Purple: '电光紫',
      White: '皎月白',
    },
    VT9S_V2: {
      Black: '星空黑',
      Electric_Purple: '电光紫',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT9_PRO_V2: {
      Black: '星空黑',
      Electric_Purple: '电光紫',
      White: '皎月白',
    },
    VT9S_PRO_V2: {
      Black: '星空黑',
      Electric_Purple: '电光紫',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT9_MAX_V2: {
      Black: '星空黑',
      Electric_Purple: '电光紫',
      White: '皎月白',
    },
    VT9S_MAX_V2: {
      Black: '星空黑',
      Electric_Purple: '电光紫',
      Raspberry_Pink: '树莓粉',
      White: '皎月白',
    },
    VT9Air_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT9SAir_MAX_V2: {
      Morning_Mist_Blue: '晨雾蓝',
    },
    VT9_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT9S_MAX_MASTER_V2: {
      Metallic_Iridescent: '幻彩',
    },
    VT68: {
      Yellow: '竞技黄',
      Black: '黑武士',
    },
    VPR8_PLUS: {
      Black: '黑色',
    },
  },
}
